<template>
  <section class="section section-shaped section-lg my-0">
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">

            <div class="text-center">
              <img class="w-100" style="max-width: 183px" :src="$baseUrl + 'img/brand/logo-1.png'">
            </div>
            <div class="mt-3"/>

            <template v-if="!sent">
              <div class="text-center text-muted mb-4">
                <small class="text-main-color">重設密碼</small>
              </div>
              <div class="mt-5"/>
              <p class="text-muted text-sm text-center mb-4">
                請輸入您的帳號信箱，我們將寄送重設密碼的連結給您。
              </p>
              <form role="form" @submit.prevent="submit">
                <base-input
                    class="mb-3"
                    placeholder="帳號信箱"
                    addon-left-icon="fa fa-envelope"
                    type="email"
                    :value="email"
                    @input="value => email = value"
                />
                <div class="text-center">
                  <base-button
                      class="w-100 my-4 font-size-16"
                      style="max-width: 160px"
                      size="lg"
                      type="main-color"
                      :disabled="loading"
                      @click="submit"
                  >
                    {{ loading ? '寄送中...' : '寄送連結' }}
                  </base-button>
                </div>
              </form>
            </template>

            <template v-else>
              <div class="text-center text-muted mb-4">
                <small class="text-main-color">郵件已寄出</small>
              </div>
              <div class="mt-5"/>
              <div class="text-center mb-4">
                <i class="fa fa-check-circle fa-3x text-main-color mb-3" style="display:block"></i>
                <p class="text-muted text-sm">
                  重設密碼連結已寄送至<br>
                  <strong>{{ email }}</strong><br>
                  請檢查您的信箱。
                </p>
              </div>
            </template>

          </card>
          <div class="row mt-3">
            <div class="col-12 text-center">
              <router-link to="/login" class="text-light">
                <small>← 返回登入</small>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      email: '',
      loading: false,
      sent: false,
    };
  },
  methods: {
    async submit() {
      if (!this.email) {
        this.$dialog.error({ text: '請輸入信箱', title: '錯誤' });
        return;
      }
      this.loading = true;
      try {
        await axios.post(`${process.env.VUE_APP_APIPATH}auth/send_reset_password`, {
          email: this.email,
        });
        this.sent = true;
      } catch (e) {
        this.$dialog.error({
          text: '寄送失敗，請稍後再試。',
          title: '錯誤',
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
